import * as React from "react";
const FaqSearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="search-icon-svg faq-search-support-svg"
    style={{
      enableBackground: "new 0 0 26.1 26.1",
    }}
    viewBox="0 0 26.1 26.1"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M11.822 21.007c-5.218 0-9.465-4.246-9.467-9.465.002-5.222 4.25-9.471 9.469-9.472 5.22 0 9.469 4.248 9.471 9.47 0 5.221-4.25 9.467-9.473 9.467zm.002-17.936c-4.668.001-8.467 3.801-8.469 8.472.002 4.667 3.8 8.465 8.467 8.465 4.672 0 8.473-3.798 8.473-8.467-.002-4.67-3.802-8.47-8.471-8.47z"
      style={{
        stroke: "#fff",
        strokeWidth: 2,
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M23.703 24.303a.502.502 0 0 1-.354-.146l-5.568-5.567a.5.5 0 0 1 .707-.707l5.568 5.567a.5.5 0 0 1-.353.853z"
      style={{
        stroke: "#fff",
        strokeWidth: 2,
        strokeMiterlimit: 10,
      }}
    />
  </svg>
);
export default FaqSearchIcon;
